function groupList (list, num = 2) {
    if (!list || !list.length) {
        return [];
    }

    list.forEach((product, index) => {
        product.index = index;
    });

    let result = [];
    for (let i = 0; i < list.length; i += num) {
        result.push(list.slice(i, i + num));
    }

    return result;
}

export function handleLowPriceData(data) {
    let retData = {};
    let {months, days} = data || {};
    retData = {
        months: months,
        groupedMonths: groupList(months, 4),
        days,
        lineNum: 4
    };
    return retData;
}

export function canJumpToGlobalPrice (cityList = []) {
    const goGlobalPriceModule = [
        'innerDestHotRankList',
        'interDestHotRankList',
        'interDestHotCountry',
        'innerHistory',
        'interHistory',
        'innerSuggestCity',
        'interSuggestCity'
    ];

    if (cityList && cityList.length === 1) {
        let parentModule = cityList[0].parentModule;
        if (goGlobalPriceModule.indexOf(parentModule) > -1) {
            return true;
        }
    } else {
        return true;
    }
    return false;
}


export function addGoDate(d, num) {
    let date = new Date(d);
    date.setDate(date.getDate() + parseInt(num, 10));
    let year = date.getFullYear();

    let month = date.getMonth() + 1;

    let dates = date.getDate();
    return year + '-' + (month >= 10 ? month : '0' + month) + '-' + (dates >= 10 ? dates : '0' + dates);
}

export function diff(a, b) {
    return parseInt(((+new Date(a)) - (+new Date(b))) / (24 * 3600 * 1000), 10);
}

export function paramUrl(obj) {
    let params = [];
    for (let key in obj) {
        if (obj[key] == 0) {
            obj[key] = obj[key].toString();
        }
        params.push(`${encodeURIComponent(key)} = ${encodeURIComponent(obj[key] || '')}`);
    }
    return params.join('&').replace(/\s+/g, '');
}

export function getQueryParam (key, url) {
    url = url || window.location.search;
    let reg = new RegExp('(^|&)' + key + '=([^&]*)(&|$)', 'i');
    let r = url.substr(1).match(reg);
    if (r) {
        return decodeURIComponent(r[2]);
    }
}